module.exports = __webpack_public_path__ + "img/vdara10.055105db.jpg";